<template>
<div>
    <div class="hello">
        <div class="bg" :style="bgb"></div>
        <!-- header头部 -->
        <div class="title">
            <div class="titleDiv">
                <!-- 头部左边logo区域 -->
                <ul>
                    <li><img src="../assets/images/logo.png" alt=""><em>云南曲靖陆良彩色沙林智慧景区</em></li>
                </ul>
                <!-- 头部右边 -->
                <div class="titleRight">
                    <em v-if="username"> 
                        <span @click="clickorders">
                            <i class="iconfont icon-huabanfuben"></i>我的订单
                        </span> 
                        <span class="login">{{username}}</span>
                        <span @click="clickLogout">退出</span>   
                    </em>    
                    <em v-else>                               
                        <span style="margin-right:30px;">
                            <router-link to="/login">登录</router-link>
                        </span>    
                        <!-- <span>
                            <router-link to="/registered">注册</router-link>
                        </span>                         -->
                    </em>
                </div>
            </div>
        </div>
        <!-- <div class="banner">
            <el-carousel trigger="click" height="420px">
                <el-carousel-item v-for="(img,index) in banner" :key="index">
                    <img :src="img.imgurl" width="100%" />
                </el-carousel-item>
            </el-carousel>
        </div> -->
        <!-- 票种类 -->
        <div class="content">
            <!-- <p class="positiondiv">当前位置 > <i>门票预订</i></p> -->
            <div class="hometiimg">
                <img src="@/assets/images/home.png" alt="">
            </div>
            <div class="contentDiv">
                <ul class="ticket">
                    <li v-for="(item,index) in data"  :key="index">
                        <img :src="item.imgurl" alt="" height="175" width="100%">
                        <div class="rrdiv">
                            <h1>
                                <em>{{item.ticketname}}</em>
                                <b>￥{{item.xprice}}</b>
                            </h1>
                            <div class="uldiv">
                                <ul>
                                    <li class="firstli">购票须知：</li>
                                    <!-- <li v-for="(elem,keys) in item.userNoticeList" :key="keys">{{keys+1}}. {{elem.content}}</li> -->
                                    <li class="explain">{{item.explain}}</li>
                                </ul>
                                <el-button :loading="btnloading" @click="clickBooking(item.id)">立即预订</el-button>
                            </div>
                        </div>
                        <!-- <transition name="slide-fade">
                            <div class="modal" v-if="modalShow[index]" @mouseleave="modalleave(index)">
                                <div class="modal-box">
                                    <h2>适用规则</h2>
                                    <ul style="line-height:26px;">
                                        <li v-for="(elem,keys) in item.userNoticeList" :key="keys">{{elem.content}}</li>
                                    </ul>
                                </div>
                            </div>
                        </transition> -->
                    </li>
                </ul>
            </div>           
        </div>
        <!-- 入园须知 -->
        <div class="notice">
            <div class="noticeDiv">
                <p class="ptitle">入园须知</p>
                <span class="spantitle">Notice to Tourists</span>
                <div class="oldiv">
                    <!-- <ol type="1"> -->
                    <ul>
                        <li v-for="(item,index) in noticeList" :key=index>
                            <span>{{item.title}}</span>
                            <p v-html="item.content"></p>
                        </li>
                    </ul>
                    <p class="ppp">
                        您可以通过服务热线电话 <i>0874-6881555</i> 进行游览咨询或建议投诉，感谢您的关注
                    </p>
                </div>
            </div>
        </div>
        <!-- 页尾 -->
        <div class="footerDiv">
            <div class="left">
                <span>热线电话：0874-6881555</span>
                <span style="margin-right:0;">开放时间：08:30-18:30</span>
                <br>
                <span>景区地址：云南省曲靖市陆良县城西南20公里</span>
                <span style="margin-right:0;">邮政编码：655699</span>
                <br>
                <span>版权所有：@2018 All Rights Rserved 云南曲靖陆良彩色沙林智慧景区</span>
            </div>
            <div class="right">
                <div style="margin-left:10px">
                    <img src="@/assets/images/wx.jpg" alt="">
                    <p>官网微信</p>
                </div>
                <!-- <div>
                    <img src="@/assets/images/wx.jpg" alt="">
                    <p>官方微博</p>
                </div> -->
            </div>
        </div>
    </div>
 </div>
</template>

<script>
import footerTail from "@/components/common/footerTail.vue";
import api from "@/api/homepage.js";
import store from "@/vuex/store";
import en from '@/language/en-US'
import zh from '@/language/zh-CN'
let Base64 = require('js-base64').Base64;
export default {
  name: "Homepage",
  data() {
    return {
      activeIndex: '1',
      username: '',      // 用户名
      banner:[],         // 轮播图
      data:[],           // 票种
      noticeList:[],     // 入园须知的内容
      modalShow:[false,false,false,false],
      bgb:{
        background:'url('+require('../assets/images/bg.jpg')+')',
        'background-size': 'cover',
        'background-repeat' :'no-repeat',
        'background-position': 'center'
      },
      btnloading: false,
      activeNames: ['0']
    };
  },
  store,
  components: {
     footerTail
  },
  inject:['reload'],
  created(){
      this.orders();        // 票样列表
      this.ticketUser();    // 查询个人信息  
      this.noticeLists();  // 查询所有可用入园须知
  },
  methods: {
    // 轮播图
    banners(){
        api.banner({}).then(Response=>{
            // //console.log(Response)
            this.banner=Response.data;
        }).catch(error=>{
            //console.log(error)
        })
    },
    // 票样列表
    orders(){   
      api.order({}).then(Response=>{
          //console.log(Response)
          this.data=Response.data.reverse();
      }).catch(error=>{
        //   location.reload()
          //console.log(error)
      })
    },
    //查询所有可用入园须知
    noticeLists(){   
      api.noticeList({}).then(Response=>{
        //   //console.log(Response)
          this.noticeList=Response.data;
      }).catch(error=>{
          //console.log(error)
      })
    },
    modalenter(index){
        this.$set(this.modalShow,index,true)
    },
    modalleave(index){
        this.$set(this.modalShow,index,false)
    },
    //点击立即预订的按钮，通过调用接口，检测用户是否登录
    clickBooking(id){
        this.btnloading = true;
        api.ticketAppUser({}).then(Response=>{
            this.$router.push({ path: '/authentication', query: { id: Base64.encode(id) }})
        }).catch(error=>{
            this.$message('您还没有登录或登录已失效，正在前往登录');    
            setTimeout(() => {                    
                this.$router.push('/login')
            }, 1000);
            this.btnloading = false;
        })
    },
    // 点击我的订单的按钮，通过调用接口，检测用户cookie是否过期
    clickorders(){
            api.ticketAppUser({}).then(Response=>{
                this.$router.push('/myOrder')
            }).catch(error=>{
                this.$message('您还没有登录或登录已失效，正在前往登录'); 
                setTimeout(() => {                    
                    this.$router.push('/login')
                }, 1000);
            })      
    },
    //退出登录
    clickLogout(){
      api.logout({}).then(Response=>{ 
        //   //console.log(Response)
          this.$message.success('退出成功');
          localStorage.removeItem("token");
          setTimeout(() => {                    
            this.reload();
          }, 2000);                
      }).catch(error=>{
          //console.log(error)
      })
    },
    // 查询个人信息
    ticketUser(){
        api.ticketAppUser({}).then(Response=>{
            //console.log(Response)
            this.username = Response.data.name;
        }).catch(error=>{
            //console.log(error)  
            this.username = '';        
        })
    },
    num(n) {
      return n < 10 ? "0" + n : "" + n;
    },
  }
 
};
</script>

<style lang="stylus" scoped>
.hello{
   width: 1200px;
   margin: 0 auto;
}
.title{
    z-index 10
    position fixed
    left 0 
    left 0
    // background-color: #16365c;
    background: url(../assets/images/tiodiv.png);     
    background-size: cover;
    box-sizing: border-box;
    color: #fff;
    font-size: 18px;
    height: 100px;
    line-height: 100px;
    width: 100%;
    a{
        color: #fff;
    }
    .titleDiv{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        .changLang{
            padding: 0 7px;
            font-size: 14px;
            line-height: 22px;
            display: inline-block;
            border-radius: 3px;
            text-align: center;
            color: #fff;
            border: 1px solid currentColor;
            -webkit-transition: .3s ease-in-out;
            transition: 0.3s ease-in-out;
        }
    }
    ul{
        float: left;
        li{
            float: left;
            cursor: pointer;
            font-size: 22px;
            letter-spacing: 1px;
            img{
                margin: 13px 46px 0 0;
                float: left;
                width: 70px;
            }
            p{
                background-color: #5C738D;
                padding: 0 54px;              
            }
            span{
                display: inline-block;
                padding: 0 114px 0 60px;
            }
        }
    }
    .titleRight{
        float: right;
        span{
            cursor:pointer;
        }
        .iconfont{
            margin-right 7px;
            font-size: 22px;
            float: left;
        }
        .login{
                padding: 0 20px 0 26px;
                border-left: solid 1px #fff;
                margin-left: 25px;
        }
    }
}
.banner{
    clear: both;
    box-shadow: 0 20px 80px -10px #16365c;
}
.bg{
    background-size: cover;
    background-repeat :no-repeat;
    background-position: center;
    position fixed
    left 0;
    top 96px;
    width 100%;
    height 100%;
    // max-width 1920px;
    z-index 1;
}
.content{
    position relative
    z-index 2
    padding-bottom: 100px;
    padding-top: 166px; 
    .positiondiv{
        padding: 118px 0 32px 0;
        font-size: 12px;
        i{
            color: #D89E58;
        }
    }
    .hometiimg{
        text-align: center;
        img{
            height: 50px;
        }
    }
    .contentDiv{
        // padding-top 30px;
        // width: 1200px;
        height: 100%;
        margin: 0 auto;
        // padding-left: 27px;
        padding: 30px 50px 0 75px
        .titleee {
            text-align: center;
            p{
                font-size: 48px;
                letter-spacing: 5px;
            }
            span{
                display: inline-block;
                font-size: 24px;
                margin: 12px 0 82px 0;
            }
        }
        .ticket{
                width 100%
                overflow hidden
                >li {
                    // box-shadow 2px 2px 10px 1px #444;
                    // box-shadow: 0 0 8px rgb(189, 189, 189);
                    position relative
                    display: flex;
                    margin 0 27px 50px 0
                    img{
                        width 266px
                        // height 125px
                        display block
                        box-shadow: -5px 0 8px #a5a5a5; 
                    }
                    .rrdiv{
                        background: #fff;
                        margin-left: 7px;
                        flex: 1;
                        padding: 20px 32px 20px 38px;
                        box-shadow: 0 0 8px #a5a5a5;
                    }
                    h1{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size 18px
                        font-weight: bold;
                        color #333
                        margin 0
                        b {
                            color #DB191D
                            font-size 18px
                            padding-right: 20px;
                        }
                    }
                    .uldiv{
                        height: 111px;
                        display: flex;
                        justify-content: space-between;
                        // align-items: center;
                    }
                    ul{
                        padding-right: 50px;
                        li{
                            font-size: 12px;
                            color: #999;
                            line-height: 1.8;
                        }
                        .firstli{
                            color: #A37D4C;
                            padding-top: 5px;
                        }
                    }
                    .explain{
                        padding-left: 10px;
                        display: -webkit-box;
                        -webkit-line-clamp: 4;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }
                    .el-button{
                        width: 90px;
                        min-width: 90px;
                        height: 30px;
                        line-height: 30px;
                        color: #fff;
                        background: #3A3A3A;
                        border-radius: 5px;
                        border: none;
                        padding: 0;
                        letter-spacing: 1px;
                        margin-top: 40px;
                    }
                    // p{
                    //     padding: 0 15px 0 15px
                    //     height: 80px;
                    //     line-height 20px
                    //     font-size 12px
                    //     color #888888
                    //     letter-spacing 0.5px
                    //     overflow: hidden;
                    //     text-overflow: ellipsis;
                    //     display: -webkit-box;
                    //     -webkit-line-clamp: 4; 
                    //     -webkit-box-orient: vertical;
                    //     height: 80px; 
                    //     text-align:left;    
                    // }
                    // span{
                    //     display inline-block
                    //     color #180c8d
                    //     font-size 12px
                    // }
                    // h3{
                    //     padding: 14px 13px 0px 13px;
                    //     font-size: 18px;
                    //     color: #333;
                    //     line-height: 18px;
                    //     margin: 0;
                    //     font-weight: 500;
                    // }
                    // .priceee{
                    //     color #d30000
                    //     font-size 18px
                    //     text-align right
                    //     padding 0 13px 10px 0
                    // }
                }
        }
        .btnDiv{
            text-align: center;
            padding-top: 55px;
            .el-button{
                padding: 16px 40px;
                font-size: 20px;
                line-height 20px;
                background-color: #214064;
                border: none;
                border-radius: 30px;
                letter-spacing: 2px;
                // box-shadow: #143256 0 0px 30px;
                 background: linear-gradient(#6a85b9, #4c6288); 
                span{
                    box-shadow 1px 1px 1px  #ffffff
                }
            }
        }
    }
}
.notice{
        position relative
        z-index 2
        background-color: #fff;
        margin: 0 75px;
    .noticeDiv{
        // width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding: 50px 0 60px 0;        
        .ptitle {          
            font-size: 32px;     
            font-weight bold      
            letter-spacing: 3px;
            padding-bottom: 16px;
        }
        .spantitle{
            font-size: 16px;
            display: block;    
        }
        .oldiv{
            width 65%;
            margin 0 auto
            text-align: left;
            padding-top: 36px;
            li {
                font-size: 16px;
                line-height: 2.2;
                padding-bottom: 12px;
                span{
                    display: block;
                    font-weight: bold;
                }
                p{
                    font-size: 14px;
                    text-align: justify;
                    // text-indent: 25px;
                }
            }
            .ppp{
                font-size: 14px;
                // padding-left: 40px;
                i{
                    color: #2978d5;
                    font-size: 16px;
                }
            }
        }
    }
}
.modal{
    position absolute
    left 0 
    top 0
    width 100%
    height 100%
    background #324359
    opacity 0.9
    color #ffffff
    display flex
    align-content center
    justify-content center
    .modal-box{
        padding 20px 18px;
        width: 100%;
        h2{
            text-align center
            font-weight 500
            font-size 14px
            line-height 14px
            margin 0
        }
    ul{
        margin-top 20px
        // width: 60%;
        font-size 12px;
         height: fit-content;
         padding-left 14px;
         list-style outside
        li{
            color:#fff
            letter-spacing 1px
            text-align: justify;
        }
    }
    }
}
//页尾

.footerDiv{
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        border-top: 1px solid #987943;
        color: #333;
        width: 100%;
        height: 280px;
        margin: 0 auto;
        margin-top: 120px;
        font-size: 14px;
        .left{
            float: left;
            padding-top: 74px;
            span{
                margin: 0 14px 25px 0;
                display: inline-block;
            }
        }
        .right{
            float: right;
            padding-top: 53px;
            text-align: center;
            >div{
                float: left;
                margin-left: 34px;
                >img{
                    width: 136px;
                }
            }
            p{
                margin-top: 10px;
            }
        }
}

</style>




// WEBPACK FOOTER //
// src/views/Homepage.vue